import api from "../axiosInstance";

export const getAllApportunityRequest = async (payload) => {
    try {
    const { page, limit } = payload;
    const response = await api.get(`/apportunityRequest/all?page=${page}&limit=${limit}`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

// Business Auto-Login (no auth required)
export const businessAutoLogin = async (token) => {
  try {
    const response = await api.get(`/apportunityRequest/business/auto-login?token=${token}`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

// Business Accept/Reject Request (no auth required)
export const businessAcceptRejectRequest = async (token, payload) => {
  try {
    const { opportunityRequestId, action, message } = payload;
    const response = await api.post(`/apportunityRequest/business/respond?token=${token}`,
      {
        opportunityRequestId,
        action,
        message,
      }
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

// Admin - Get opportunity request conversations
export const getAdminOpportunityRequestConversations = async (opportunityRequestId) => {
  try {
    const response = await api.get(`/apportunityRequest/admin/conversations/${opportunityRequestId}`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};
  